var _g, _circle, _circle2, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCreateVilNonActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 106,
    viewBox: "0 0 106 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_df_3891_84754)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 43,
    fill: "#3E74B5",
    fillOpacity: 0.5,
    shapeRendering: "crispEdges"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 43,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 53,
    r: 39,
    fill: "#949292"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.6853 47.7857H41.4612V40.9286C41.4612 37.5885 44.0829 34.7143 47.375 34.7143H59.4138C62.6845 34.7143 65.3276 37.6101 65.3276 40.9286V47.7857H61.1034V42C61.1034 41.6336 60.8308 41.3571 60.4698 41.3571C60.1089 41.3571 59.8362 41.6336 59.8362 42V47.7857H46.9526V42C46.9526 41.6336 46.6799 41.3571 46.319 41.3571C45.958 41.3571 45.6853 41.6336 45.6853 42V47.7857ZM58.0186 62.7769C58.0186 65.1677 56.1086 67.1055 53.7439 67.1139C51.3793 67.1139 49.4693 65.1677 49.4693 62.7769C49.4693 60.3778 51.3875 58.44 53.7439 58.44C56.1086 58.44 58.0186 60.3861 58.0186 62.7769ZM50.9575 60.6043H51.8422C51.9827 60.1764 52.1647 59.799 52.3798 59.4885C51.8173 59.7317 51.3214 60.1176 50.9575 60.6043ZM50.2381 62.5001H51.528C51.5444 62.0304 51.6023 61.5774 51.6933 61.1664H50.6103C50.4035 61.569 50.2795 62.022 50.2381 62.5001ZM51.6933 64.3791C51.6023 63.9765 51.5444 63.5319 51.528 63.0621H50.2381C50.2713 63.5319 50.4035 63.9765 50.6018 64.3791H51.6933ZM52.4045 66.0821C52.1812 65.7718 51.9911 65.3859 51.8505 64.9412H50.9493C51.3214 65.4362 51.8258 65.8389 52.4045 66.0821ZM53.4711 64.9496H52.4292C52.6856 65.6374 53.0493 66.1408 53.4711 66.3002V64.9496ZM53.4711 63.0621H52.082C52.0984 63.5319 52.1563 63.9765 52.2556 64.3791H53.4711V63.0621ZM53.4711 61.1664H52.2556C52.1563 61.5774 52.0984 62.0304 52.0737 62.5001H53.4711V61.1664ZM53.4711 59.2536C53.0493 59.4131 52.6856 59.9079 52.4292 60.6043H53.4711V59.2536ZM55.1164 59.4969C55.3314 59.8071 55.5132 60.1847 55.6539 60.6126H56.5386C56.1665 60.126 55.6786 59.7403 55.1164 59.4969ZM54.0251 60.6043H55.0752C54.8188 59.9081 54.4468 59.4131 54.0251 59.2536V60.6043ZM54.0251 62.5001H55.4224C55.3977 62.0304 55.3396 61.5774 55.2406 61.1664H54.0251V62.5001ZM54.0251 64.3791H55.2406C55.3398 63.9765 55.3977 63.5319 55.4224 63.0621H54.0251V64.3791ZM55.0752 64.9496H54.0251V66.3002C54.4466 66.1491 54.8188 65.6458 55.0752 64.9496ZM56.5551 64.9412H55.6621C55.5132 65.3859 55.3231 65.7718 55.0999 66.0821C55.6786 65.8389 56.1747 65.4446 56.5551 64.9412ZM57.2578 63.0621H55.968C55.9515 63.5319 55.8936 63.9765 55.8026 64.3791H56.8939C57.0926 63.9765 57.2166 63.5319 57.2578 63.0621ZM56.8859 61.1664H55.8028C55.9021 61.5774 55.9517 62.0304 55.9682 62.5001H57.258C57.2248 62.022 57.0926 61.569 56.8859 61.1664ZM49.4776 71.1405H58.0186V69.4125H49.4776V71.1405ZM78 48.8571V54.6429H72.931V78H33.8578V54.6429H29V48.8571H78ZM60.7305 55.3948H59.3249V53.4066L46.2695 54.9921V74.5714H60.7307L60.7305 55.3948ZM58.3244 55.3948V54.5475L51.3791 55.3948H58.3244ZM53.3938 33.6966C56.0062 33.6966 58.1725 31.5204 58.1725 28.8482C58.1725 26.1763 56.0275 24 53.3938 24C50.7602 24 48.615 26.1763 48.615 28.8484C48.6152 31.5204 50.7389 33.6966 53.3938 33.6966Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_df_3891_84754",
    x: 0,
    y: 0,
    width: 106,
    height: 106,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_3891_84754"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3891_84754"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3891_84754",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5,
    result: "effect2_foregroundBlur_3891_84754"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateVilNonActive);
export default __webpack_public_path__ + "static/media/CreateVILNonActive.86a27adea7b9a7e965070657b3049709.svg";
export { ForwardRef as ReactComponent };